export default __webpack_public_path__ + "static/media/img_resistor.9eeaeb25.png";